"use client"

import { ContentfulLivePreview } from "@contentful/live-preview"
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react"
import { useEffect, useState } from "react"

interface ConditionalContentfulPreviewProps {
  children: React.ReactNode
}

export default function ConditionalContentfulPreview({
  children,
}: ConditionalContentfulPreviewProps) {
  const [enablePreview, setEnablePreview] = useState(false)

  useEffect(() => {
    // Check if we're in Contentful preview mode AND not on a qualified domain
    const isQualified =
      window.location.hostname.includes("qualified.com") ||
      window.location.hostname.includes("qualified-preview.com")
    const isDraftMode =
      document.cookie.includes("__prerender_bypass") ||
      document.referrer.includes("app.contentful.com")

    const shouldEnable = !isQualified && isDraftMode
    setEnablePreview(shouldEnable)

    // Only initialize if we should enable preview
    if (shouldEnable) {
      try {
        ContentfulLivePreview.init({ locale: "en-US" })
      } catch (error) {
        // Already initialized, ignore
      }
    }
  }, [])

  // Only render ContentfulLivePreviewProvider when we actually want to enable it
  // This prevents the provider from initializing on Qualified domains
  if (enablePreview) {
    return (
      <ContentfulLivePreviewProvider enableLiveUpdates locale="en-US">
        {children}
      </ContentfulLivePreviewProvider>
    )
  }

  // Otherwise, render children without any Contentful provider
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
